import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LoaderService, RestService } from '@stdoutsrl/design-kit';
import { api } from '../../../environments/environment';

@Component({
    selector: 'app-availability',
    templateUrl: './availability.component.html',
    styles: [],
    standalone: false
})
export class AvailabilityComponent implements OnInit {
  constructor(
    private rest:RestService,
    private loader:LoaderService
  ){}
  ships: any[] = []
  baseUrl = api.baseUrl

  ngOnInit(): void {
    this.loader.on()
    let params = {
      "month": 2,
      "year": 2026
    }
    this.rest.post('/slot/monthly',params).subscribe({
      next:(value:any)=> {
        this.ships = value
        this.loader.off(true)
      },
      error:(value)=> {
        this.loader.off(true)
      },
    })
  }
}
